import React from 'react';
import { Heart, MessageCircle } from 'react-feather';
import MonoAvatar from '../../MonoAvatar';
import {
  InlineShell,
  InlineEyebrow,
  formatRelativeShort,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

interface Post {
  id?: string;
  postId?: string;
  text?: string;
  authorHandle?: string;
  likeCount?: number;
  replyCount?: number;
  createdAt?: any;
}

function PostRow({ post, onAction }: { post: Post; onAction?: OnAction }) {
  const id = post.postId || post.id;
  const author = post.authorHandle || '';
  const handleDisplay = author.startsWith('@') ? author : author ? `@${author}` : '';
  const text = post.text || '';
  const when = formatRelativeShort(post.createdAt);
  const likes = post.likeCount || 0;
  const replies = post.replyCount || 0;

  return (
    <button
      type="button"
      className="f8c-post-row"
      onClick={() =>
        onAction?.({
          action: 'navigate',
          params: { screen: 'PplTalk', postId: id },
        })
      }
    >
      <div className="f8c-post-head">
        <MonoAvatar name={author || 'Anonymous'} size={28} />
        <span className="f8c-post-handle">{handleDisplay || 'anonymous'}</span>
        {when && <span className="f8c-post-when">· {when}</span>}
      </div>

      <p className="f8c-post-text">{text}</p>

      {(likes > 0 || replies > 0) && (
        <div className="f8c-post-meta">
          {likes > 0 && (
            <span className="f8c-post-meta-item">
              <Heart size={12} />
              {likes}
            </span>
          )}
          {replies > 0 && (
            <span className="f8c-post-meta-item">
              <MessageCircle size={12} />
              {replies}
            </span>
          )}
        </div>
      )}
    </button>
  );
}

export default function PostsListCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const posts: Post[] = card?.data?.posts || [];
  if (posts.length === 0) return null;

  return (
    <InlineShell>
      <InlineEyebrow label={`${posts.length} posts`} />
      <div className="f8c-post-list">
        {posts.map((post, i) => (
          <PostRow key={post.postId || post.id || i} post={post} onAction={onAction} />
        ))}
      </div>
    </InlineShell>
  );
}
